/** Every console message from this bundle carries the same prefix — the designer guide tells people to search for it. */
const PREFIX = '[tour-event]';

export const warn = (message: string, ...rest: unknown[]) => console.warn(`${PREFIX} ${message}`, ...rest);
export const error = (message: string, ...rest: unknown[]) => console.error(`${PREFIX} ${message}`, ...rest);
